<template>
  <div>
    <NothingFound
      v-if="!laboratoryList.length"
      data-qa="laboratories-list-content-not-found"
    />
    <div
      v-else
      data-qa="laboratories-list-content-labs"
    >
      <div
        v-for="(item, index) in laboratoryList"
        :key="`${index}-${item.id}`"
        v-ripple
        :data-qa="`laboratories-list-content-lab-item-${item.lpu.id}`"
        class="py-3 cursor-pointer d-flex align-center justify-space-between"
        :class="xSpaceClass"
        @click="handleClickLab(item)"
      >
        <div>
          <div
            class="text-body-1 text--text"
            data-qa="laboratories-list-content-lab-name"
          >
            {{ item.lpu.name }}
          </div>
          <div
            class="text-body-2 text-secondary--text"
            data-qa="laboratories-list-content-lab-address"
          >
            {{ item.lpu.town.name }}, {{ item.lpu.address }}
          </div>
        </div>
        <div class="ui-icon-arrow-right icon-secondary--text" />
      </div>
      <div
        v-if="hasLoadMoreLine"
        v-intersect="handleIntersect"
        class="d-flex justify-center align-center px-1 py-4"
        data-qa="laboratories-list-content-lab-more-text"
      >
        <div class="text-body-1">
          Загружаем ещё...
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import NothingFound from 'www/vue_components/common/Analyses/pages/PartnerAnalysesPage/components/NothingFound.vue'
import useLabsStore from 'www/vue_components/common/Analyses/components/LaboratoriesList/stores/useLabsStore'
import { computed } from 'vue'
import { Laboratory } from 'www/vue_components/common/Analyses/types'

defineProps<{
  xSpaceClass?: string
}>()

type Emits = {
  (_e: 'click:lab', _: { id: number, lpu: Laboratory }): void
}

const emit = defineEmits<Emits>()

const labsStore = useLabsStore()
const {
  labPaginator,
  requestLabListLazyLoad,
  updateLaboratory,
} = labsStore
const { laboratoryList } = storeToRefs(labsStore)

const hasLoadMoreLine = computed(() => (labPaginator.current < labPaginator.total))

function handleClickLab(item: { id: number, lpu: Laboratory }) {
  updateLaboratory(item.lpu)
  emit('click:lab', item)
}

async function handleIntersect(entries: any, observer: any, isIntersecting: boolean) {
  if (isIntersecting) {
    await requestLabListLazyLoad()
  }
}
</script>
